import { render, staticRenderFns } from "./maxpro-info.vue?vue&type=template&id=f654a7a0&"
import script from "./maxpro-info.vue?vue&type=script&lang=js&"
export * from "./maxpro-info.vue?vue&type=script&lang=js&"
import style0 from "./maxpro-info.vue?vue&type=style&index=0&lang=sass&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports


//////////////////
// WEBPACK FOOTER
// ./src/templates/pages/axoft-maximum-pro/components/maxpro-info.vue
// module id = 1248
// module chunks = 0